import axios from 'axios'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import AsyncSelect, { useAsyncSelect } from '../../../common/AsyncSelect'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import { FUNDING } from '../../../constants/divisions'
import {
  ACCOUNT_STATUS,
  INACTIVE_STATUS,
  LEAD_STATUS,
  MANAGER_BUCKET_STATUS,
  PENDING_STATUS,
  PROSPECT_STATUS,
} from '../../../constants/statuses'
import { notificationDanger, notificationSuccess } from '../../../utils/customToastify'
import { getAllDivisions } from '../../Divisions/redux/DivisionActions'

const ChangeContactStatus = () => {
  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState({
    contactId: null,
    divisionId: null,
    statusId: null,
  })

  const dispatch = useDispatch()
  const { fetchOptions } = useAsyncSelect()
  const { divisions } = useSelector((state) => ({
    divisions: state.divisions?.divisions?.data,
  }))

  const statusesOptions = React.useMemo(() => {
    const commons = [
      { label: 'Lead', value: LEAD_STATUS },
      { label: 'Prospect', value: PROSPECT_STATUS },
      { label: 'Account', value: ACCOUNT_STATUS },
      { label: 'Manager`s Bucket', value: MANAGER_BUCKET_STATUS },
      { label: 'Inactive', value: INACTIVE_STATUS },
    ]

    if ([FUNDING].includes(data.divisionId)) {
      commons.push({ label: 'Pending', value: PENDING_STATUS })
    }

    return commons
  }, [data.divisionId])

  const divisionsOptions = React.useMemo(() => {
    if (divisions && Array.isArray(divisions)) {
      const options = []

      divisions.forEach((division) => {
        if (division.id !== 1) {
          options.push({ value: division.id, label: division.name })
        }
      })

      return options
    }

    return []
  }, [divisions])

  React.useEffect(() => {
    const loadData = () => {
      dispatch(getAllDivisions())
    }
    loadData()
  }, [])

  const onSaveClick = async () => {
    try {
      setLoading(true)
      await axios.post('/contacts/change-contact-status-without-additional-actions', {
        ...data,
        creationDate: new Date(),
      })
      setLoading(false)
      notificationSuccess('Successfully changed status!')
    } catch (e) {
      setLoading(false)
      notificationDanger('Something went wrong!')
    }
  }

  const loadContactOptions = async (inputValue, options) => {
    const data = await fetchOptions('/contacts/contacts-for-async-select', { q: inputValue, ...options })
    return data
  }

  const selectHandler = (val, e) => {
    setData((oldData) => ({ ...oldData, [e.name]: val && val.value ? val.value : null }))
  }

  return (
    <>
      <Row>
        <Col md='4'>
          <AsyncSelect
            label='Select Contact'
            isClearable
            onChange={selectHandler}
            loadOptions={loadContactOptions}
            name='contactId'
          />
        </Col>
        <Col md='4'>
          <CustomSelect
            isClearable
            name='divisionId'
            defaultValue={data.divisionId}
            options={divisionsOptions}
            label='Select Division'
            placeholder={'Select...'}
            onChange={selectHandler}
          />
        </Col>
        <Col md='4'>
          <CustomSelect
            isClearable
            name='statusId'
            defaultValue={data.statusId}
            options={statusesOptions}
            label='Select Status'
            placeholder={'Select...'}
            onChange={selectHandler}
          />
        </Col>
      </Row>
      <Row className='mt-5'>
        <Col className='d-flex justify-content-end'>
          <Button className='btn btn-sm btn-gold' onClick={onSaveClick} disabled={loading}>
            Save
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default ChangeContactStatus
